<template>
    <div class="uikid">
	    <div class="icons">
		    <div v-for="id in ids" :key="id" class="icon">
			    <svg-sprite :icon-id="id" :width="28" :height="28"/>
			    <div class="name">{{ id }}</div>
		    </div>
	    </div>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        ID
                    </th>
                    <th class="text-left">
                        W
                    </th>
                    <th class="text-left">
                        H
                    </th>
                    <th class="text-left">
                        Icon
                    </th>
                    <th class="text-left">
                        Icon borders
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in icons"
                    :key="item.id"
                >
                    <td>{{ item.id }}</td>
                    <td>{{ item.w }}</td>
                    <td>{{ item.h }}</td>
                    <td>
                        <svg-sprite :width="item.w" :height="item.h" :icon-id="item.id"></svg-sprite>
                    </td>
                    <td>
                        <span class="icon">
                            <svg-sprite :width="item.w" :height="item.h" :icon-id="item.id"></svg-sprite>
                        </span>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

// constants
import { icons } from "@/constants/uiKidConstants";

export default {
	name: "UiKid",
	computed: {
		icons() {
			return icons;
		},
	},
	data: () => ({ ids: [] }),
	async mounted() {
		// заміни шлях на свій (напр., '/img/sprite.svg' або import spriteUrl from '...')
		const res = await fetch('@/assets/sprite.svg');
		const text = await res.text();
		const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
		this.ids = [ ...doc.querySelectorAll('symbol[id]') ].map(s => s.id);
	}
};
</script>

<style lang="scss" scoped>
.uikid {
    .icon {
        display: inline-block;
        border: 1px solid;
        svg {
            display: block;
        }
    }
}

.icons{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px}
.icon{display:flex;align-items:center;gap:8px;padding:8px;border:1px dashed #ddd;border-radius:10px}
.name{font:12px/1.2 ui-monospace, SFMono-Regular, Menlo, monospace;opacity:.8}
</style>

<!--&lt;!&ndash; SpriteGallery.vue &ndash;&gt;-->
<!--<template>-->
<!--	<div class="icons">-->
<!--		<div v-for="id in ids" :key="id" class="icon">-->
<!--			<svg-sprite :icon-id="id" :width="28" :height="28"/>-->
<!--			<div class="name">{{ id }}</div>-->
<!--		</div>-->
<!--	</div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--	name: 'UiKid',-->
<!--	data: () => ({ ids: [] }),-->
<!--	async mounted() {-->
<!--		// заміни шлях на свій (напр., '/img/sprite.svg' або import spriteUrl from '...')-->
<!--		const res = await fetch('@/assets/sprite.svg');-->
<!--		const text = await res.text();-->
<!--		const doc = new DOMParser().parseFromString(text, 'image/svg+xml');-->
<!--		this.ids = [ ...doc.querySelectorAll('symbol[id]') ].map(s => s.id);-->
<!--	}-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--.icons{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px}-->
<!--.icon{display:flex;align-items:center;gap:8px;padding:8px;border:1px dashed #ddd;border-radius:10px}-->
<!--.name{font:12px/1.2 ui-monospace, SFMono-Regular, Menlo, monospace;opacity:.8}-->
<!--</style>-->
